import * as React from "react"
import { useLocation, Link } from "react-router-dom"
import {
  Bot,
  Compass,
  type LucideIcon,
} from "lucide-react"

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

interface ExploreItem {
  title: string
  url: string
  icon: LucideIcon
  isActive?: boolean
}

export const NavExplore = React.memo(function NavExplore() {
  const location = useLocation()

  const exploreItems: ExploreItem[] = [
    {
      title: "Knowledge Beacons",
      url: "/beacons",
      icon: Bot,
      isActive: location.pathname === "/beacons" || location.pathname.startsWith("/beacons/"),
    },
    {
      title: "Sparks",
      url: "/sparks",
      icon: Compass,
      isActive: location.pathname === "/sparks" || location.pathname.startsWith("/sparks/"),
    },
  ]

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Explore</SidebarGroupLabel>
      <SidebarMenu>
        {exploreItems.map((item) => (
          <SidebarMenuItem key={item.title}>
            <SidebarMenuButton asChild tooltip={item.title} isActive={item.isActive}>
              <Link to={item.url}>
                <item.icon className="h-4 w-4" />
                <span>{item.title}</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
});
